import React, { memo } from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select';
import PropTypes from 'prop-types';

import { useSimpleLoyaltyList } from 'api/simple';
import { TRuleCreatePage } from 'containers/Rule/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

interface LoyaltyProgramSelectProps extends SelectProps {
  value: number;
  onChange?: (loyaltyId: number, program: any) => void;
  disabledOptionsIds?: number[];
}

export const LoyaltyProgramSelect: React.FC<LoyaltyProgramSelectProps> = ({
  value,
  onChange,
  disabledOptionsIds = [],
  ...props
}) => {
  const { data = [], isLoading } = useSimpleLoyaltyList();

  const onSelectionChange = id => {
    const program = data.find(item => item.id === id);
    onChange(id, program);
  };

  const options = data.map(program => ({
    value: program.id,
    label: program.name,
    disabled: disabledOptionsIds.indexOf(program.id) > -1
  }));

  const { t } = useMultiLanguageTranslation();

  return (
    <Select
      value={isLoading ? null : value}
      loading={isLoading}
      onChange={onSelectionChange}
      placeholder={t(`${TRuleCreatePage}.RuleSetup.LoyaltyProgramSelectPlaceholder`)}
      options={options}
      {...props}
      onBlur={e => e.preventDefault()}
    />
  );
};

LoyaltyProgramSelect.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
};

export default memo(LoyaltyProgramSelect);
